import * as firebase from '../'
import {User} from "@/model";

const db = firebase.firestore;

const getUserData = async (userId) => {
    const userRef = db.collection('users').doc(`${userId}`);
    try {
        const userDocument = await userRef.get();
        // console.log(userDocument.exists ? userDocument.data() : '');
        return userDocument.exists ? userDocument.data() : null;
    } catch (e) {
        console.error(e)
    }
};

const createUserData = async (userId) => {
    const userRef = db.collection('users').doc(`${userId}`);
    await userRef.set(User);
    return User
};

const updateUserData = async (userId, payload) => {
    const userRef = db.collection('users').doc(`${userId}`);
    const result = await userRef.update(payload);
    console.log(result);
    return result;
};

const createOrGetUserData = async (userId) => {
    const userDoc = await getUserData(userId);
    if (userDoc !== null) {
        return userDoc
    } else {
        const result = await createUserData(userId);
        console.log(result);
        return result;
    }
};

export {
    createOrGetUserData,
    createUserData,
    getUserData,
    updateUserData
}
